var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid',{ref:"grid",staticClass:"no-grid-border",attrs:{"config":_vm.gridConfig},on:{"handleCustomButtonGrid":_vm.handlerAddToRFQ3}})}
var staticRenderFns = []

export { render, staticRenderFns }